import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import React from 'react'
import KasKrsStyleV12 from '../styles/KasKrsStyleV12'

const KasKrsV12 = ({ data, onSetSectionData, hasError, onLoadGUS }) => {
  return (
    <KasKrsStyleV12>
      <FormControl component="fieldset" className="text">
        <TextField
          error={hasError('NrNIP')}
          name="NrNIP"
          label="NIP"
          title={data.NrNIP}
          value={data.NrNIP}
          margin="normal"
          helperText="10 cyfr, bez myślników i spacji"
          onChange={onSetSectionData}
        />
      </FormControl>
      <FormControl component="fieldset" className="text">
        <TextField
          error={hasError('NrKRS')}
          name="NrKRS"
          label="Numer KRS"
          title={data.NrKRS}
          value={data.NrKRS}
          margin="normal"
          helperText={
            '10 cyfr, bez myślników i spacji. Podanie KRS jest obowiązkowe dla jednostek wpisanych do Krajowego Rejestru Sądowego.'
          }
          onChange={onSetSectionData}
        />
      </FormControl>
      <FormControl component="fieldset">
        <Button
          data-cy="getGus"
          className="buttonGUS"
          variant="contained"
          color="primary"
          onClick={() => {
            if (data.NrNIP) onLoadGUS(data.NrNIP)
          }}
        >
          POBIERZ DANE Z GUS
        </Button>
      </FormControl>
    </KasKrsStyleV12>
  )
}

export default KasKrsV12
